//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'
import FeedbackBlockItem from "~/components/feedback-block/FeedbackBlockItem.vue";
import FeedbackBlockPopup from '~/components/feedback-block/FeedbackBlockPopup.vue'
export default BaseCmsBlock.extend({
  name: 'FeedbackBlock',

  components: {
    FeedbackBlockItem,
    FeedbackBlockPopup
  },

  data: function () {
    return {
      swiperOptions: {
        // slidesPerView: 5,
        speed: 1000,
        spaceBetween: 24,
        centerSlides: true,
        // loop: this.extras?.items.length > 1,
        loop: false,
        navigation: {
          prevEl: '.feedback-swiper__button-navigation--prev',
          nextEl: '.feedback-swiper__button-navigation--next'
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1000: {
            slidesPerView: 4,
            spaceBetween: 22,
          },
        },
      },
      selectedCard: null,
      isOpenPopup: false,
    }
  },

  computed: {
    items: function () {
      return this.extras?.items || [];
    },
    blockTitle: function () {
      return this.values?.title || '';
    },
    blockDescription: function () {
      return this.values?.text || '';
    }
  },
  methods: {
    openPopup: function (item) {
      this.selectedCard = item;
      this.isOpenPopup = true;
    },
    closePopup: function () {
      this.selectedCard = null;
      this.isOpenPopup = false;
    }
  }
})

